import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';







const alertpopup=(data)=>{
       
    toast.success(data,{
        theme:"colored",
    });
}


export const AddUser= async(data)=>{

    const url='https://whatsup-6v48.onrender.com/addUser'

    try {
        await axios.post(url,data)
        .then((res)=>{
        //  console.log(res.data.msg)
        })
        .catch((res)=>{
            console.log(res.data.msg)
        })
    } catch (error) {
        console.log(error)
    }

    
      
}


export const ConversationBetweenTwo= async(data)=>{

    const url='https://whatsup-6v48.onrender.com/conversation'

    try {
        await axios.post(url,data)
        .then((res)=>{
        //  console.log(res.data.msg)
        })
        .catch((res)=>{
            console.log(res.data.msg)
        })
    } catch (error) {
        console.log(error)
    }

        
}



export const SendMessage= async(data)=>{


    const url='https://whatsup-6v48.onrender.com/sendMessage'

    try {
        await axios.post(url,data)
        .then((res)=>{
        //  console.log(res.data.msg)
         
          
        })
        .catch((res)=>{
            console.log(res.data.msg)
        })
    } catch (error) {
        console.log(error)
    }

        
}

 




export const GetMessage= async(idd)=>{
 
    const url='https://whatsup-6v48.onrender.com/getmessage'

    try {
      let res=  await axios.post(url,{conversationId:idd})
       
          //console.log(res.data.data)
          let data=res.data.data
          return data
        
    } catch (error) {
        console.log(error)
    }
 }

 

 export const Upload= async(file)=>{
    const url='https://whatsup-6v48.onrender.com/file/uploadImage'
    try {
        let res= await axios.post(url,file)
        let data=res.data.data
        console.log(data)
        return data
    } catch (error) {
         console.log(error)
    }

 }



 export const getConversation= async(iddd)=>{
    const url='https://whatsup-6v48.onrender.com/getConversation'
    try {
        let res= await axios.post(url,iddd)
        let data=res.data.data
        return data
       
    } catch (error) {
         console.log(error)
    }

 }